module.exports = __webpack_public_path__ + "static/media/logo.dc70fcd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 819
// module chunks = 0